/* Bloodline UI: product-row filter tabs (sliding pill) and image hotspots. No dependencies. */
(function () {
  if (window.BLUI) return;

  /* ---------- Tabs ---------- */
  function movePill(tabs) {
    var on = tabs.querySelector('[aria-selected="true"]');
    var pill = tabs.querySelector('.bl-tabs__pill');
    if (!on || !pill) return;
    pill.style.left = on.offsetLeft + 'px';
    pill.style.width = on.offsetWidth + 'px';
  }

  function select(tab) {
    var tabs = tab.closest('[data-bl-tabs]');
    var section = tab.closest('[data-bl-row]');
    if (!tabs || !section || tab.getAttribute('aria-selected') === 'true') return;
    tabs.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    movePill(tabs);
    var target = tab.getAttribute('aria-controls');
    section.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      var show = panel.id === target;
      panel.hidden = !show;
      if (show) {
        panel.classList.remove('is-entering');
        void panel.offsetWidth;
        panel.classList.add('is-entering');
        panel.querySelectorAll('.bl-reveal').forEach(function (el) { el.classList.add('is-in'); });
        setTimeout(function () { panel.classList.remove('is-entering'); }, 700);
      }
    });
    var url = tab.getAttribute('data-url');
    section.querySelectorAll('[data-bl-tab-link]').forEach(function (a) { if (url) a.href = url; });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-bl-tabs]').forEach(function (tabs) {
      movePill(tabs);
      if (tabs._blTabs) return;
      tabs._blTabs = true;
      tabs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var all = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
        var i = all.indexOf(document.activeElement);
        if (i < 0) return;
        var next = all[(i + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
        next.focus();
        select(next);
      });
      if ('ResizeObserver' in window) new ResizeObserver(function () { movePill(tabs); }).observe(tabs);
    });
  }

  /* ---------- Hotspots ---------- */
  function toggleHotspot(btn) {
    var spot = btn.closest('.bl-hotspot');
    var open = !spot.classList.contains('is-open');
    document.querySelectorAll('.bl-hotspot.is-open').forEach(function (s) {
      s.classList.remove('is-open');
      s.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
    });
    spot.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-bl-tabs] [role="tab"]');
    if (tab) { select(tab); return; }
    var hs = e.target.closest('.bl-hotspot__btn');
    if (hs) { e.preventDefault(); toggleHotspot(hs); return; }
    if (!e.target.closest('.bl-hotspot')) {
      document.querySelectorAll('.bl-hotspot.is-open').forEach(function (s) {
        s.classList.remove('is-open');
        s.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
      });
    }
  });

  function init(root) { initTabs(root || document); }

  window.BLUI = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  window.addEventListener('load', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
